import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { SuppliersSchema } from 'Modules/Suppliers/Schemas/TherapySchema';
import { ITherapySuppliers } from 'Interfaces/therapySuppliers';
import { useContext } from 'react';
import { IDoctorsSuppliers } from 'Interfaces/doctorsSuppliers';
import { DoctorsSchema } from 'Modules/Suppliers/Schemas/DoctorsSchema';
import {
  DoctorsSuppliersContext,
  defaultDoctorsFilters,
} from 'Context/SuppliersContext/DoctorsSuppliersContext';

export const useDoctorsSuppliersForm = () => {
  const { filters } = useContext(DoctorsSuppliersContext);

  const DoctorsSuppliersForm = useForm<IDoctorsSuppliers>({
    mode: 'all',
    resolver: yupResolver(DoctorsSchema),
    defaultValues: { ...defaultDoctorsFilters, ...filters },
  });

  return {
    DoctorsSuppliersForm,
  };
};
